<template>
    <div>
        Results:
        <b-row v-for="result in searchResults" :key="'row_'+result.id">
            <b-col cols="12">
                <hr>
            </b-col>
            <b-col cols="6">
                <WorkBox :work="result" :key="result.id"></WorkBox>
                <p>{{result.description}}</p>
            </b-col>
            <b-col cols="6">
                <img style="width: 100%;" :src="apiURL+result.coverimage.url" alt="">
            </b-col>

        </b-row>
        <p v-if="this.$store.state.searchResults<1">nothing found.</p>
        <div>


        </div>
    </div>
</template>

<script>
    import WorkBox from "../components/WorkBox";

    export default {
        name: "SearchResults",
        components: {WorkBox},
        computed: {
            searchResults: function () {
                return this.$store.state.searchResults
            },
            apiURL: function () {
                return process.env.VUE_APP_API_URL
            }
        }
    }
</script>

<style scoped>

</style>